var _defs, _circle, _line, _line2, _line3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew313({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 12.02,
    r: 1.84
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 4.42,
    x2: 8,
    y2: 10.19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.59,
    y1: 3,
    x2: 9.41,
    y2: 5.83
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.41,
    y1: 3,
    x2: 6.59,
    y2: 5.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.38,5.63V2.41H.73V3.73H2.1V2.41h.35V5.63H2.1V4.11H.73V5.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.92,4.5l.35.11a1.48,1.48,0,0,1-.41.81,1,1,0,0,1-.7.27,1.07,1.07,0,0,1-.63-.18,1.28,1.28,0,0,1-.43-.58A2.38,2.38,0,0,1,2.94,4a2.16,2.16,0,0,1,.16-.9,1.27,1.27,0,0,1,.45-.56,1.17,1.17,0,0,1,.64-.19,1,1,0,0,1,.65.24,1.23,1.23,0,0,1,.39.7l-.34.1c-.12-.45-.36-.67-.71-.67a.78.78,0,0,0-.46.13.93.93,0,0,0-.31.42A1.94,1.94,0,0,0,3.3,4a1.69,1.69,0,0,0,.23,1,.71.71,0,0,0,.62.33.7.7,0,0,0,.49-.2A1.12,1.12,0,0,0,4.92,4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew313);
export default __webpack_public_path__ + "static/media/Symbolpack_New_313.2ed7222673a8b5a3648057e5a5c132e9.svg";
export { ForwardRef as ReactComponent };